export default __webpack_public_path__ + "static/media/ionq.8b34fe60.jpeg";